"use client";
import { Button } from "@/components/ui/button";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";

export interface EditCardButtonProps {
  subscriptions: string[];
  disabled?: boolean;
}

export const EditCardButton = (props: EditCardButtonProps) => {
  const { subscriptions, disabled } = props;

  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const t = useTranslations("Fleet");

  const checkout = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/stripe/checkout/update", {
        method: "POST",
        headers: { "Content-Type": "applicaton/json" },
        body: JSON.stringify({
          subscriptionIds: subscriptions,
        }),
      });
      if (!res.ok) return;

      const data = await res.json();

      const redirect = data.redirect as string;
      router.push(redirect);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [router, subscriptions]);

  return (
    <Button disabled={disabled || loading} onClick={checkout}>
      {t("updatecard")}
    </Button>
  );
};
